import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGetPlayerByMlbIdQuery } from "../store/api/mlbApi";
import { getPlayerPath } from "../utils/fanPage";
import { isMlbPersonId } from "../utils/playerHeadshots";

const MISSING_MLB_PLAYER_MESSAGE =
  "We don't have a full page for this player yet";

export const useResolvedPlayerId = (routeId) => {
  const navigate = useNavigate();
  const mlbId = isMlbPersonId(routeId) ? String(routeId).trim() : null;
  const mlbQuery = useGetPlayerByMlbIdQuery(mlbId, { skip: !mlbId });

  useEffect(() => {
    const canonicalId = mlbQuery.data?.playerId;
    if (!mlbId || !canonicalId) return;
    const path = getPlayerPath(canonicalId);
    if (!path || path === getPlayerPath(routeId)) return;
    navigate(path, { replace: true });
  }, [mlbId, mlbQuery.data?.playerId, navigate, routeId]);

  if (!mlbId) {
    return {
      playerId: routeId || null,
      isResolving: false,
      unavailable: false,
      errorMessage: null,
    };
  }

  return {
    playerId: mlbQuery.data?.playerId || null,
    isResolving:
      mlbQuery.isUninitialized || mlbQuery.isLoading || mlbQuery.isFetching,
    unavailable: mlbQuery.isError,
    errorMessage:
      mlbQuery.error?.data?.error || MISSING_MLB_PLAYER_MESSAGE,
  };
};
